import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { refundStatusOptions } from '@/common/constants'

const RefundStatusSelector = ({ value, onChange }) => {
  const { t } = useTranslation()

  return (
    <ComboBox
      value={value}
      label={t('Estado de reembolso')}
      handleChange={e => onChange(e.target.value)}
      menuItems={refundStatusOptions.map(o => ({ label: t(o.label), value: o.value }))}
    />
  )
}

export default RefundStatusSelector
